(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scrolling-collections"] && !window.DesignMode) return;
  try {
    
// Auto-bounce scrolling with manual swipe and pause/play
document.addEventListener('DOMContentLoaded', function() {
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const inner    = document.querySelector('.scrolling-collection__inner');
  const track    = document.querySelector('.scrolling-collection__track');
  const toggle   = document.querySelector('.scroll-toggle');
  const gap      = parseFloat(getComputedStyle(track).gap) || 0;

  const totalWidth     = track.scrollWidth;
  const viewWidth      = inner.clientWidth;
  const maxOffset      = Math.max(0, totalWidth - viewWidth);

  const speedSeconds   = parseInt(track.dataset.speed, 10);
  const halfDurationMs = (speedSeconds * 1000) / 2;
  const speedPerMs     = maxOffset / halfDurationMs;

  let offset    = 0;
  let direction = 1;
  let paused    = false;
  let lastTime  = null;
  let resumeTO;

  let dragging    = false;
  let startX      = 0;
  let startOffset = 0;

  const PAUSE_SVG = '<svg viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
  const PLAY_SVG  = '<svg viewBox="0 0 24 24"><polygon points="5,3 19,12 5,21"/></svg>';

  function clamp(v) { return Math.max(0, Math.min(maxOffset, v)); }
  function pauseFor(ms) {
    paused = true;
    clearTimeout(resumeTO);
    resumeTO = setTimeout(() => { paused = false; lastTime = null; }, ms);
  }

  function animate(ts) {
    if (!paused && !dragging) {
      if (lastTime !== null) {
        const dt = ts - lastTime;
        offset = clamp(offset + direction * speedPerMs * dt);
        if (offset === maxOffset || offset === 0) {
          direction = offset === maxOffset ? -1 : 1;
          pauseFor(1000);
        }
        if (isMobile) inner.scrollLeft = offset;
        else track.style.transform = `translateX(-${offset}px)`;
      }
      lastTime = ts;
    }
    requestAnimationFrame(animate);
  }
  requestAnimationFrame(animate);

  inner.addEventListener('touchstart', e => {
    dragging = true;
    pauseFor(2000);
    startX = e.touches[0].pageX;
    startOffset = offset;
  }, { passive: true });

  inner.addEventListener('touchmove', e => {
    const dx = e.touches[0].pageX - startX;
    offset = clamp(startOffset - dx);
    inner.scrollLeft = offset;
  }, { passive: true });

  inner.addEventListener('touchend', () => {
    dragging = false;
    lastTime = null;
  });

  track.addEventListener('mouseenter', () => pauseFor(2000));
  track.addEventListener('mouseleave', () => {
    paused = false;
    lastTime = null;
  });

  document.querySelectorAll('.scroll-arrow').forEach(btn => {
    btn.addEventListener('click', () => {
      pauseFor(2000);
      const dir = btn.dataset.direction === 'right' ? 1 : -1;
      offset = clamp(offset + dir * viewWidth);
      track.style.transform = `translateX(-${offset}px)`;
      lastTime = null;
    });
  });

  toggle.addEventListener('click', () => {
    paused = !paused;
    clearTimeout(resumeTO);
    toggle.innerHTML = paused ? PLAY_SVG : PAUSE_SVG;
    toggle.setAttribute('aria-label', paused ? 'Play scrolling' : 'Pause scrolling');
    lastTime = null;
  });
});

  } catch(e) { console.error(e); }
})();
})();
